
import ic_home from "../../assets/img/icons/ic_home.svg"
import ic_training from "../../assets/img/icons/ic_training.svg"
import ic_profile from "../../assets/img/icons/ic_profile.svg"
import CONFIG_COMPANY from "../../services/myConfig";
import swal from "sweetalert2";
import AdminApi from "../../services/api";
import session from "../../services/session";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    name: 'sssss',
    data() {
        return {
            locale: LocService,
            theme: 'teal',
            selectedItem: 'home',
            ic_home: ic_home,
            ic_training: ic_training,
            ic_profile: ic_profile,
            model: {
                id: 0,
                email: '',
                name: '',
                phone: '',
                surname: '',
                username: '',
                role: null
            },
            expireDate: null,
            restOfTraining: 0,
        }
    },
    methods: {
        onClickItem: onClickItem,
        loadUser: loadUser,
        isMobileAndUser(){
            if(window.innerWidth > 767) return true;
            return session.getRole() === 'ROLE_ADMIN' || session.getRole() === 'ROLE_SUPER_ADMIN';
        },
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('getMe', (data) => {
            _self.model = data;
            console.log(data);
        });
    },
    beforeMount() {
        if(window.location.href.includes("home")){
            this.selectedItem = "bottom-bar-item-home";
        }else if(window.location.href.includes("trainings")){
            this.selectedItem = "bottom-bar-item-trainings";
        }else if(window.location.href.includes("profile")){
            this.selectedItem = "bottom-bar-item-profile";
        }else if(window.location.href.includes("my-payments")){
            this.selectedItem = "bottom-bar-item-payments";
        } else{
            this.selectedItem = null;
        }
        if(!this.isMobileAndUser()){
            this.loadUser();
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        }
    },
    watch:{
        $route (to, from){
            if(to.name.includes('home')){
                this.selectedItem = "bottom-bar-item-home";
                return;
            }
            switch (to.name){
                case "home": this.selectedItem = "bottom-bar-item-home"; break;
                case "trainings": this.selectedItem = "bottom-bar-item-trainings"; break;
                case "profile": this.selectedItem = "bottom-bar-item-profile"; break;
                case "my-payments": this.selectedItem = "bottom-bar-item-payments"; break;
                default: this.selectedItem = null; break
            }
        }
    },

    components: {}
}

function onClickItem(id) {
    switch (id) {
        case 1:
            this.$router.push(CONFIG_COMPANY.HOME);
            break;
        case 2:
            this.$router.push('/trainings');
            break;
        case 3:
            this.$router.push('/my-payments?id=' + this.model.id + '&name=' + this.model.name + ' ' + this.model.surname + '&restOfTrainings=' + this.model.restOfTraining + '&expireDate=' + this.model.expireDate)
            break;
        case 4:
            this.$router.push('/profile');
            break;
    }
}


function loadUser() {
    let _self = this;
    if(localStorage.getItem('ACCESS_TOKEN') == null) return;
    AdminApiService.getProfile()
        .then((response) => {
            _self.model =  response.data;
        })
        .catch(error => {
            console.log(error)
            // swal('Greška', error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/Layout/BottomBar.js